import { render, staticRenderFns } from "./CloseBead.vue?vue&type=template&id=18eb2087&scoped=true"
import script from "./CloseBead.vue?vue&type=script&lang=js"
export * from "./CloseBead.vue?vue&type=script&lang=js"
import style0 from "./CloseBead.vue?vue&type=style&index=0&id=18eb2087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eb2087",
  null
  
)

export default component.exports